import React, { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { Edit, Trash } from "react-feather";
import { fetchCategory } from "../../service/CategoryService";
import { fetchVendor } from "../../service/VendorService";
import { apiUrl } from "../../config";
import { fetchProductImageByProductId } from "../../service/ProductImageService";
import { formatDate } from "../../App";

const ProductsList = ({ productData, handleEdit, handleDelete }) => {
  const [categories, setCategories] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [productImages, setProductImages] = useState({});

  const fetchData = async () => {
    try {
      const res = await fetchCategory();
      const res2 = await fetchVendor();
      setCategories(res);
      setVendors(res2);

      const imagePromises = productData.map(async (product) => {
        const images = await fetchProductImageByProductId(product.id);
        return { productId: product.id, images };
      });

      const results = await Promise.all(imagePromises);

      const imageMap = {};
      results.forEach(({ productId, images }) => {
        imageMap[productId] = images;
      });

      setProductImages(imageMap);
    } catch (error) {
      console.error("Error in fetching", error);
    }
  };

  useEffect(() => {
    if (productData?.length > 0) {
      fetchData();
    }
  }, [productData]);

  return (
    <Table
      striped
      bordered
      hover
      responsive
      className="align-middle text-center"
    >
      <thead className="table-dark">
        <tr>
          <th>S.No</th>
          <th>Code</th>
          <th>Name</th>
          <th>Image</th>
         <th>Weight</th>
          <th>Making Charges</th>
          <th>Wastage Charges</th>
          <th>Status</th>
          <th>Stock Availability</th>
          <th>Purchase Rate</th>
          <th>Purchase GoldRate</th>
          <th>Purchase Date</th>
          <th>Vendor</th>
          <th>Category</th>
          <th>Product Type</th>
          <th style={{ minWidth: "154px" }}>Action</th>
        </tr>
      </thead>
      <tbody>
        {productData?.map((data, index) => {
          const images = productImages[data.id] || [];
          const firstImage = images.length > 0 ? images[0].imageUrl : null;

          return (
            <tr key={data.id}>
              <td>{index + 1}</td>
              <td>{data.code}</td>
              <td>{data.name}</td>
              <td>
                {firstImage ? (
                  <img
                    src={`${apiUrl}/${firstImage}`}
                    alt={data.type}
                    className="student-thumbnail"
                    style={{
                      objectFit: "contain",
                      height: "70px",
                      width: "70px",
                      border: "1px solid #ddd",
                    }}
                  />
                ) : (
                  "No Image"
                )}
              </td>
              <td>{data.weight}</td>
              <td>{data.makingCharge}</td>
              <td>{data.wastageCharge}</td>
              <td>{data.status}</td>
              <td>{data.stockAvailability}</td>
              <td>{data.purchaseRate}</td>
              <td>{data.purchaseGoldRate}</td>
              <td>{formatDate(data.purchaseDate)}</td>
              <td>{vendors?.find((d) => d.id === data.vendorId)?.name}</td>
              <td>{categories?.find((d) => d.id === data.categoryId)?.name}</td>
              <td>{data.productType}</td>
              
              <td>
                <Button
                  variant="warning"
                  size="sm"
                  className="me-2"
                  onClick={() => handleEdit({data, images: productImages[data.id]})}
                >
                  <Edit size={18} />
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleDelete(data.id)}
                >
                  <Trash size={18} />
                </Button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default ProductsList;
